import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";

import Header from "components/Header";
import HeaderCheckout from "components/Header/Checkout";
import Footer from "components/Footer";

const LayoutContainer = ({ children }) => {
  const location = useLocation();
  const isPageCheckout = location?.pathname.startsWith("/checkout");

  return (
    <>
      {isPageCheckout ? <HeaderCheckout /> : <Header />}
      <div className={isPageCheckout ? "mt-0" : "m-t-70"}>{children}</div>
      <Footer />
    </>
  );
};

LayoutContainer.propTypes = {
  children: PropTypes.element.isRequired,
};

export default LayoutContainer;
